import store from "@/store";
import Layout from "@/layout/index";

/**
 * 字符权限校验
 * @param {Array} value 校验值
 * @returns {Boolean}
 */
export function checkPermi(value) {
  if (value && value instanceof Array && value.length > 0) {
    const permissions = store.getters && store.getters.permissions;
    const permissionDatas = value;
    const all_permission = "*:*:*";

    const hasPermission = permissions.some(permission => {
      return (
        all_permission === permission || permissionDatas.includes(permission)
      );
    });

    if (!hasPermission) {
      return false;
    }
    return true;
  } else {
    console.error(
      `need roles! Like checkPermi="['system:user:add','system:user:edit']"`
    );
    return false;
  }
}

/**
 * 角色权限校验
 * @param {Array} value 校验值
 * @returns {Boolean}
 */
export function checkRole(value) {
  if (value && value instanceof Array && value.length > 0) {
    const roles = store.getters && store.getters.roles;
    const permissionRoles = value;
    const super_admin = "admin";

    const hasRole = roles.some(role => {
      return super_admin === role || permissionRoles.includes(role);
    });

    if (!hasRole) {
      return false;
    }
    return true;
  } else {
    console.error(`need roles! Like checkRole="['admin','editor']"`);
    return false;
  }
}

/**
 * 初始化 菜单数据
 */
export function initMenu(permissions) {
  // 配置 后台权限
  const munArr = [
    {
      path: "/CourseManagement",
      component: Layout,
      // component: resolve => require(["../layout"], resolve),
      meta: {
        PermissionID: "36130170-89a1-11ee-8e66-34735aa3266e",
        title: "课程管理"
      },
      children: [
        {
          path: "/CourseManagement",
          name: "content-course",
          meta: {
            PermissionID: "36130170-89a1-11ee-8e66-34735aa3266e",
            title: "课程管理"
          },
          component: () => import("@/views/back/CourseManagement")
        }
      ]
    },
    {
      path: "/BBS",
      component: Layout,
      children: [
        {
          path: "/BBS",
          name: "content-BBS",
          meta: {
            PermissionID: "7407811a-89a1-11ee-8e66-34735aa3266e",
            title: "宠播社区"
          },
          component: () => import("@/views/back/BBSmanagement")
        }
      ]
    },
    {
      path: "/comments",
      component: Layout,
      children: [
        {
          path: "/comments",
          name: "content-comments",
          meta: {
            PermissionID: "880769ec-89a1-11ee-8e66-34735aa3266e",
            title: "评论管理"
          },
          component: () => import("@/views/back/commentsManagement")
        }
      ]
    },
    {
      path: "/user",
      component: Layout,
      children: [
        {
          path: "/user",
          name: "content-user",
          meta: {
            PermissionID: "985f43ad-89a1-11ee-8e66-34735aa3266e",
            title: "用户管理"
          },
          component: () => import("@/views/back/userManagement")
        }
      ]
    },
    {
      path: "/lecturer",
      component: Layout,
      children: [
        {
          path: "/lecture",
          name: "content-lecturer",
          meta: {
            PermissionID: "a7d0ba9d-89a1-11ee-8e66-34735aa3266e",
            title: "讲师管理"
          },
          component: () => import("@/views/back/lecturerManagement")
        }
      ]
    },
    {
      path: "/banner",
      component: Layout,
      children: [
        {
          path: "/banner",
          name: "content-banner",
          meta: {
            PermissionID: "be4a3df4-89a1-11ee-8e66-34735aa3266e",
            title: "banner管理"
          },
          component: () => import("@/views/back/bannerManagement")
        }
      ]
    },
    {
      path: "/reception",
      component: Layout,
      children: [
        {
          path: "/reception",
          name: "customer-reception",
          meta: {
            PermissionID: "0af58a47-89a2-11ee-8e66-34735aa3266e",
            title: "客户接待"
          },
          component: () =>
            import("@/views/back/Chat/CustomerReception/CustomerReception")
        }
      ]
    },
    {
      path: "/Account",
      component: Layout,
      children: [
        {
          path: "/Account",
          name: "Account-management",
          meta: {
            PermissionID: "4f1252ce-89a2-11ee-8e66-34735aa3266e",
            title: "账户管理"
          },
          component: () =>
            import("@/views/back/Chat/AccountManagement/AccountManagement")
        }
      ]
    },
    {
      path: "/Problem",
      component: Layout,
      children: [
        {
          path: "/Problem",
          name: "Problem-management",
          meta: {
            PermissionID: "2a2e8356-89a2-11ee-8e66-34735aa3266e",
            title: "问题管理"
          },
          component: () =>
            import("@/views/back/ProblemManagement/ProblemManagement")
        }
      ]
    },
    {
      path: "/Product",
      component: Layout,
      children: [
        {
          path: "/Product",
          name: "Product-support",
          meta: {
            PermissionID: "f2b3feef-89a1-11ee-8e66-34735aa3266e",
            title: "产品支持"
          },
          component: () => import("@/views/back/ProductSupport/ProductSupport")
        }
      ]
    },
    {
      path: "/Record",
      component: Layout,
      children: [
        {
          path: "/Record",
          name: "Record-management",
          meta: {
            PermissionID: "3bc8280f-89a2-11ee-8e66-34735aa3266e",
            title: "接待记录管理"
          },
          component: () =>
            import("@/views/back/RecordManagement/RecordManagement")
        }
      ]
    }
  ];
  const aRouter = [];
  permissions.forEach(i => {
    munArr.forEach(m => {
      if (i.PermissionID === m.children[0].meta.PermissionID) {
        aRouter.push(m);
      }
    });
  });
  return aRouter;
}



// WEBPACK FOOTER //
// ./src/utils/permission.js